import React from 'react'
import { toFloat, inputDevider } from '../../../../helper.ts'
import { IResults } from '../../../../types'

const Result: React.FC<IResults> = ({name, result, currency}) => {
  console.log(result);
  
  const floatResult = toFloat(result.toString()) || 0
  return (
    <div className='calculator__result'>
      <div className='calculator__result__inner'>
        <div className='calculator__result__header'>
          { name }
        </div>
        <div className='calculator__result__container'>
          <div className='calculator__result__text'>
            <span> { currency }{ inputDevider(floatResult) }</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Result
